//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
import IndexService from '@/service/index'
import WX_API from '@/utils/wx_api'
import canvas_save from '@/common/mixins/canvas_save'
import { App_User } from '@/data/user_info'
import { drawConsultantCard } from '@/common/utils/canvas'
import { sendCtmEvtLog } from '@/utils/log'
export default {
    components: {
    },
    mixins: [
        canvas_save
    ],
    props:{
        rate: [Object, Array],
        scene: String,
        jump_page: String
    },
    data () {
        return {
            canvas_w: 0,
            canvas_h: 0,
            image_url: '',
            is_consultant: false,
            consultant: {},
            qrcode: '',
            show_view: false
        }
    },
    created () {},
    methods: {
        async getRateImageUrl (img) {
            const data = await WX_API.getImgInfo(img)
            return data
        },
        async getQrCodePath (qrcode) {
            const { path } = await WX_API.getImgInfo(qrcode)
            return path
        },
        async getConsultantHeadimgPath (headimg) {
            const { path } = await WX_API.getImgInfo(headimg)
            return path
        },
        async getWxQrCodePath () {
            const { path } = await WX_API.getImgInfo('https://cdn.vip-wifi.com/fangchan/img/loan_rate/qr.jpeg')
            return path
        },
        drawImg ({ image_url_path, image_url_h, canvas_w, canvas_h, qrcode, headimg, wxQrcode }) {
            const canvasId = 'rate-canvas'
            const ctx = wx.createCanvasContext(canvasId, this.$mp.component)
            const CANVAS_WIDTH = canvas_w
            const CANVAS_HEIGHT = canvas_h

            const contact_text_style = {
                font: 'normal 24px PingFang SC',
                color: '#666666',
                x: 190,
                LH: 24,
                marginT: 12
            }

            // draw background
            ctx.setFillStyle('#FFFFFF')
            ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)

            // draw img
            ctx.drawImage(image_url_path, 0, 0, CANVAS_WIDTH, image_url_h)

            // draw wxQrcode
            if (!this.is_consultant) {
                ctx.drawImage(wxQrcode, 630, 16, 100, 100)
                ctx.font = 'normal 20px PingFang SC'
                ctx.fillStyle = '#8A9996'
                ctx.textBaseline = 'top'
                ctx.textAlign = 'center'
                ctx.fillText('扫码查看', 680, 124)
            } else {
                // draw consultant
                drawConsultantCard(ctx, {
                    headImage: {
                        path: headimg,
                        x: 48,
                        y: image_url_h + 34,
                        r: 56,
                        marginR: 24
                    },
                    headImageBg: {
                        r: 60,
                        fillStyle: '#E0E0E0'
                    },
                    name: {
                        text: this.consultant.name,
                        color: '#333333',
                        font: 'normal bold 34px PingFangSC-Medium',
                        x: 190,
                        y: image_url_h + 30,
                        LH: 34
                    },
                    tagBg: {
                        color: '#DAF7F3',
                        y: image_url_h + 26,
                        h: 36,
                        marginL: 16
                    },
                    tag: {
                        text: '置业顾问',
                        color: '#00C2A7',
                        font: 'normal 18px PingFang SC'
                    },
                    houseName: {
                        text: `楼盘：${this.consultant.building_name}`,
                        ...contact_text_style
                    },
                    wx: {
                        text: `微信：${this.consultant.weixin_name}`,
                        ...contact_text_style
                    },
                    tel: {
                        text: `手机：${this.consultant.mobile}`,
                        ...contact_text_style
                    },
                    qr: {
                        path: qrcode,
                        x: 580,
                        y: image_url_h + 24,
                        r: 60
                    },
                    qrBg: {
                        r: 63,
                        fillStyle: '#E0E0E0'
                    },
                    qrLabel: {
                        color: '#999999',
                        font: 'normal 20px PingFang SC',
                        text: '长按查看更多'
                    }
                })
            }

            ctx.draw(true, () => {
                console.log('-----finishDraw-----')
                this.finishDraw({
                    canvasId,
                    width: CANVAS_WIDTH,
                    height: CANVAS_HEIGHT
                })
            })
        },
        generateImgs ({ rateImageInfo, qrTemp, headimgTemp, wxQrTemp }) {
            const { width, height, path } = rateImageInfo
            this.canvas_w = width / 2
            this.canvas_h = (height / 2) + (this.is_consultant ? 198 : 0)
            // this.drawImg({
            //     image_url_path: path,
            //     image_url_h: height / 2,
            //     canvas_w: this.canvas_w,
            //     canvas_h: this.canvas_h,
            //     qrcode: qrTemp,
            //     wxQrcode: wxQrTemp,
            //     headimg: headimgTemp
            // })
            this.save()
            setTimeout(() => {
                this.show_view = true
            }, 1000)
        },
        async onSaveImage () {
            sendCtmEvtLog(`利率表生成图片-点击`)
            if (this.tmp_img_path) {
                this.show_view = true
                return
            }
            wx.showLoading({
                title: '',
                mask: true
            })
            const { image_url } = this.rate.month_info
            const { is_consultant } = await App_User.get()
            this.is_consultant = is_consultant
            if (is_consultant) {
                const consultant = await IndexService.getMyConsultant()
                const { weixin_headimgurl } = consultant
                this.consultant = consultant
                const { qrcode } = await PublicService.getSceneQr({
                    scene: this.scene,
                    jump_page: this.jump_page
                })
                this.qrcode = qrcode
                wx.hideLoading()
                const [rateImageInfo, qrTemp, headimgTemp, wxQrTemp] = await Promise.all([this.getRateImageUrl(image_url), this.getQrCodePath(qrcode), this.getConsultantHeadimgPath(weixin_headimgurl), this.getWxQrCodePath()])
                this.generateImgs({
                    rateImageInfo,
                    qrTemp,
                    headimgTemp,
                    wxQrTemp
                })
            } else {
                wx.hideLoading()
                const [rateImageInfo, wxQrTemp] = await Promise.all([this.getRateImageUrl(image_url), this.getWxQrCodePath()])
                this.generateImgs({
                    rateImageInfo,
                    qrTemp: '',
                    headimgTemp: '',
                    wxQrTemp
                })
            }
        },
        hide () {
            this.show_view = false
        }
    }
}
